import gql from "graphql-tag";
const GET_SESSION_DATA_BY_KEY = gql`
	query ($key: String!) {
		value: sessionDataValueInfoByKey(key: $key) {
			expiredOn
			data
		}
	}
`;
const REMOVE_SESSION_DATA_BY_KEY = gql`
	mutation ($key: String!) {
		removeSessionDataValueByKey(key: $key)
	}
`;
export {
  GET_SESSION_DATA_BY_KEY,
  REMOVE_SESSION_DATA_BY_KEY
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Vzc2lvbi1zdG9yZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyYXBocWwvc2Vzc2lvbi1zdG9yZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZ3FsIGZyb20gXCJncmFwaHFsLXRhZ1wiO1xuXG5leHBvcnQgY29uc3QgR0VUX1NFU1NJT05fREFUQV9CWV9LRVkgPSBncWxgXG5cdHF1ZXJ5ICgka2V5OiBTdHJpbmchKSB7XG5cdFx0dmFsdWU6IHNlc3Npb25EYXRhVmFsdWVJbmZvQnlLZXkoa2V5OiAka2V5KSB7XG5cdFx0XHRleHBpcmVkT25cblx0XHRcdGRhdGFcblx0XHR9XG5cdH1cbmA7XG5cbmV4cG9ydCBjb25zdCBSRU1PVkVfU0VTU0lPTl9EQVRBX0JZX0tFWSA9IGdxbGBcblx0bXV0YXRpb24gKCRrZXk6IFN0cmluZyEpIHtcblx0XHRyZW1vdmVTZXNzaW9uRGF0YVZhbHVlQnlLZXkoa2V5OiAka2V5KVxuXHR9XG5gOyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBRU8sTUFBTSwwQkFBMEI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQVNoQyxNQUFNLDZCQUE2QjtBQUFBO0FBQUE7QUFBQTtBQUFBOyJ9
